<app-page-meta pageTitle="finzy - Apply for a loan with finzy"
               tags="finzy, line of credit online, easy finance, need a loan, india credit finance, personal loans, easy loans, loan, loan india, current loan rates india, best loans india, best loan rates, cheapest loans india, quick personal loans, low interest personal loans"
               description="finzy is the premier peer to peer lending solution in India. We connect borrowers with investors and make loans simple and easy. With low interest rates, a hassle free loan application process, no prepayment charges, no lock-in periods, finzy is the best place to apply for a personal loan.">
</app-page-meta>

<app-header></app-header>

<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <div class="rightarrow"></div>
    <div class="leftinnerdiv">
      <p class="lefttxt">Hello there!</p>
      <p class="lefttxt2">Welcome to finzy</p>
    </div>
    <div class="leftarrow"></div>
  </div>
  <div class="col-sm-8 rightdiv">
    <div class="rightinnerdiv">
      <p class="introtxt">We have identified {{name | titlecase}} as your financial advisor from the referral partner
        code you have entered.</p>
        <p class="subtext">By choosing <strong>"I accept"</strong>, you will be agreeing to provide read only access of your investments to
          your financial advisor or any platform they use to manage your investments. Below is a summary of the information accessible to them.</p>
      <p class="subtext font-bold mt-3 mb-1">Your financial advisor will be able to : </p>
        <ul>
            <li class="subtext">View information about your investments.</li>
        </ul>
      <p class="subtext font-bold mt-3 mb-1">Will not be able to : </p>
      <ul>
          <li class="subtext">Create an investment portfolio</li>
          <li class="subtext">Update your investment preferences</li>
          <li class="subtext">Update your personal information</li>
      </ul>
      <div class="buttons">
        <button mat-stroked-button class="button-back primary"
                (click)="back()"><i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
        </button>
        <button mat-flat-button class="primary"
                (click)="goNext(); analyticsTracker.trackButtonClick('Lender referral','GET STARTED')">
          I &nbsp;ACCEPT &nbsp;&nbsp;&nbsp;<i class="material-icons">arrow_forward</i>&nbsp;&nbsp;&nbsp;
        </button>
      </div>
    </div>
  </div>
</div>
  <app-footer></app-footer>
